import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import FitMessage from './components/fit-message/fit-message';
import FitmentBanner from '../fitment-banner/fitment-banner';

import { useFitment } from '../../shared/hooks/hooks';

import { trackAction } from '../../shared/utils/analytics/analytics';
import { ProductTypeProp } from '../../shared/utils/prop-types/prop-types';

import { DONT_FIT, EXCLUDED, FIT } from '../../shared/constants/fit';

import './fitment-page-banner.scss';

function FitmentPageBanner(props) {
  const {
    className,
    doesFitEnum,
    hideDivider,
    productType,
    isLoading,
    isPackage,
    isTextSearch,
    isSingular,
    onEditFitment
  } = props;

  const { selectedFitment } = useFitment();

  const defaultEditFitment = useCallback(() => {
    window.location.hash = '#/fitment/vehicle/edit/confirm';
  }, []);

  return (
    <div className={className} styleName="container">
      {!selectedFitment && (
        <FitMessage
          data-testid="FitMessage"
          doesFit={false}
          isPackage={isPackage}
          isSingular={isSingular}
          productType={productType}
        />
      )}
      {selectedFitment && doesFitEnum !== EXCLUDED && (
        <FitMessage
          data-testid="FitMessage"
          doesFit={doesFitEnum === FIT}
          fitment={selectedFitment}
          isLoading={isLoading}
          isPackage={isPackage}
          isSingular={isSingular}
          isTextSearch={isTextSearch}
          productType={productType}
        />
      )}
      {selectedFitment && (
        <FitmentBanner
          fitment={selectedFitment}
          onEditFitment={() => {
            typeof onEditFitment === 'function'
              ? onEditFitment()
              : defaultEditFitment();
            trackAction('vehicle_page_edit');
          }}
          showChangeVehicleLink
          showEditLink
          styleName="fitment-banner"
        />
      )}
      {selectedFitment && !hideDivider && <hr styleName="vehicle-divider" />}
    </div>
  );
}

FitmentPageBanner.propTypes = {
  className: PropTypes.string,
  doesFitEnum: PropTypes.oneOf([DONT_FIT, EXCLUDED, FIT]),
  hideDivider: PropTypes.bool,
  isLoading: PropTypes.bool,
  isPackage: PropTypes.bool,
  isSingular: PropTypes.bool,
  isTextSearch: PropTypes.bool,
  onEditFitment: PropTypes.func,
  productType: ProductTypeProp
};

export default FitmentPageBanner;
